import type { FunctionComponent, ReactNode } from 'react';
import ContentLoader from 'react-content-loader';
import { useSelector } from 'react-redux';
import * as IssuesV2Store from '../../../../../redux/issuesV2';

type Props = {
  children: (contentStartY: number) => ReactNode;
};

/**
 * Generic loading state for the issue drawer. This component displays the loading state for the
 * header section, status, action buttons, and tabs.
 */
const IssueGenericLoading:FunctionComponent<Props> = ({ children }) => {
  const scope = useSelector(IssuesV2Store.selectors.getScope);
  const isProjectScope = scope.type === 'project';
  const contentStartY = isProjectScope ? 210 : 130;

  return (
    <ContentLoader width="100%" height="1800px">
      {/* Header Section */}
      <rect x="0" y="0" rx="3" ry="3" width="40%" height="20" />
      <rect x="0" y="30" rx="3" ry="3" width="45%" height="25" />
      <rect x="0" y="60" rx="3" ry="3" width="40%" height="20" />
      {/* Status */}
      <rect x="0" y="90" rx="3" ry="3" width="35%" height="20" />
      {/* Action Buttons */}
      {isProjectScope && <rect x="0" y="130" rx="3" ry="3" width="85" height="30" />}
      {isProjectScope && <rect x="95" y="130" rx="3" ry="3" width="85" height="30" />}
      {/* Tabs */}
      <rect x="0" y={contentStartY} rx="3" ry="3" width="12%" height="32" />
      <rect x="15%" y={contentStartY} rx="3" ry="3" width="12%" height="32" />
      <rect x="30%" y={contentStartY} rx="3" ry="3" width="12%" height="32" />
      <rect x="0" y={contentStartY + 42} rx="3" ry="3" width="95%" height="2" />
      {children(contentStartY)}
    </ContentLoader>
  );
};

export default IssueGenericLoading;
